import * as z from 'zod';

import { LosId } from '../../BrandedIds';
import { FeeType } from '../../events/CreateChargeEvent';
import { zodBrandedString } from '../../utils';
import { Checkbox, DateString, PositiveMonetaryValue } from '../fields';
import { trimAndStrip } from '../utils';
import { InvestorSplit } from './RecordDrawDisbursementRow';

export const BaseCreateLoanFeeRow = z.object({
  loanId: zodBrandedString<LosId>(),
  feeType: FeeType,
  feeName: z.string().optional().describe('Name of the fee if fee type is "Other"'),
  statementAppliedDate: DateString.optional().describe(
    'Late fees can be applied to specific statements (must be the 1st or 25th of the month)',
  ),
  feeTotal: PositiveMonetaryValue,
  deferFee: Checkbox.prefault('no').optional().describe('If not provided, the fee will not be deferred to payoff'),
  investorRemittanceSplit: InvestorSplit.optional().describe(
    'If not provided, the fee will be applied 100% to the lender',
  ),
  note: z.string().optional(),
});

export const CreateLoanFeeRow = BaseCreateLoanFeeRow.superRefine((data, ctx) => {
  /**
   * The UI currently (a) only allows fee name to be entered for "Other" fee type
   * and (b) makes it an optional field for "Other" fee type.
   */
  if (data.feeType !== 'OTHER' && trimAndStrip(data.feeName) != null) {
    ctx.addIssue({
      code: 'custom',
      message: 'Fee name is only allowed when fee type is "Other"',
      path: ['feeName'],
    });
  }
});

export type CreateLoanFeeRow = z.infer<typeof BaseCreateLoanFeeRow>;

export const CREATE_LOAN_FEE_ROW_REQUIRED_FIELDS = Object.keys(BaseCreateLoanFeeRow.shape).filter(
  (key) => !BaseCreateLoanFeeRow.shape[key as keyof typeof BaseCreateLoanFeeRow.shape].isOptional(),
) as (keyof CreateLoanFeeRow)[];
